import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition } from '@wix/sdk-types';
import { createTaxGroup as universalCreateTaxGroup, deleteTaxGroup as universalDeleteTaxGroup, getTaxGroup as universalGetTaxGroup, listDefaultTaxGroups as universalListDefaultTaxGroups, listDefaultTaxGroupsByAppIds as universalListDefaultTaxGroupsByAppIds, queryTaxGroups as universalQueryTaxGroups, updateTaxGroup as universalUpdateTaxGroup, } from './billing-v1-tax-group-tax-groups.universal.js';
export const __metadata = { PACKAGE_NAME: '@wix/ecom' };
export function createTaxGroup(httpClient) {
    return (taxGroup) => universalCreateTaxGroup(taxGroup, 
    // @ts-ignore
    { httpClient });
}
export function getTaxGroup(httpClient) {
    return (taxGroupId) => universalGetTaxGroup(taxGroupId, 
    // @ts-ignore
    { httpClient });
}
export function updateTaxGroup(httpClient) {
    return (_id, taxGroup) => universalUpdateTaxGroup(_id, taxGroup, 
    // @ts-ignore
    { httpClient });
}
export function deleteTaxGroup(httpClient) {
    return (taxGroupId) => universalDeleteTaxGroup(taxGroupId, 
    // @ts-ignore
    { httpClient });
}
export function queryTaxGroups(httpClient) {
    return () => universalQueryTaxGroups(
    // @ts-ignore
    { httpClient });
}
export function listDefaultTaxGroups(httpClient) {
    return () => universalListDefaultTaxGroups(
    // @ts-ignore
    { httpClient });
}
export function listDefaultTaxGroupsByAppIds(httpClient) {
    return (appIds) => universalListDefaultTaxGroupsByAppIds(appIds, 
    // @ts-ignore
    { httpClient });
}
export const onTaxGroupCreated = EventDefinition('wix.billing.v1.tax_group_created', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export const onTaxGroupDeleted = EventDefinition('wix.billing.v1.tax_group_deleted', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'undefined.createdDate' },
            { path: 'undefined.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export const onTaxGroupUpdated = EventDefinition('wix.billing.v1.tax_group_updated', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export { SortOrder, WebhookIdentityType, } from './billing-v1-tax-group-tax-groups.universal.js';
//# sourceMappingURL=billing-v1-tax-group-tax-groups.public.js.map